import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import LocalizedLink from './components/LocalizedLink.vue'
import { i18n } from './i18n'
import router from './router'
import './assets/camplist.css'
import './assets/public-pages.css'

createApp(App).use(createPinia()).use(i18n).use(router).component('RouterLink', LocalizedLink).mount('#app')
